<template>
  <div class="rank-page">
    <Header :title="title"></Header>
    <div class="detail">
      <CheckInInfo :join_user="detail.user"></CheckInInfo>
    </div>
    <div class="lines"></div>
    <van-tabs v-model="active"
              @click="setTYpe"
              title-active-color="#333333"
              title-inactive-color="#BEBEBE">
      <van-tab v-for="(item,index) in tabs"
               :key="index"
               :title="item.title"></van-tab>
    </van-tabs>
    <div class="record_content">
      <div class="item userRank"
           v-if="myRank.user">
        <div class="nickname">
          <i>{{myRank.rank}}</i>
          <img :src="myRank.user.avatar"
               alt="avatar">
          <span class="name"> {{myRank.user.nickname}}</span>
        </div>
        <div v-if="type=='days'">打卡{{myRank.total_days}}天</div>
        <div v-if="type=='score'">{{myRank.total_score}}分</div>
      </div>
      <div class="lines"></div>
      <Empty v-if="!detail.list|| !detail.list.length"
             :empty_type="{name: '暂无打卡记录'}"></Empty>
      <div v-if="detail.list&&detail.list.length">
        <div class="item"
             v-for="(item,index) in detail.list"
             :key="index">
          <div class="nickname">
            <i v-if="index>2">{{index+1}}</i>
            <i v-else
               :class="'rank_icon'+index"></i>
            <img :src="item.user.avatar"
                 alt="avatar">
            <span class="name"> {{item.user.nickname}}</span>
          </div>
          <div v-if="type=='days'">打卡{{item.total_days}}天</div>
          <div v-if="type=='score'">{{item.total_score}}分</div>
        </div>
      </div>
    </div>
    <div class="toTop"
         v-if="btnFlag"
         @click="backTop">
      <img src="~@/assets/images/toTop.png"
           alt="toTop">
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header";
import List from "@/components/List";
import CheckInInfo from "@/components/checkIn/CheckInInfo";
import Empty from "@/components/Empty";
export default {
  name: "Rank",
  components: {
    List,
    Header,
    CheckInInfo,
    Empty
  },
  data () {
    return {
      title: {
        name: "打卡排行榜"
      },
      id: null,
      detail: {},
      active: 0,
      type: 'score',
      myRank: {},
      btnFlag: false,
      tabs: [{ title: '总得分排名', id: 1 }, { title: '打卡天数排名', id: 2 }]
    };
  },
  created () {
    this.id = this.$route.query.id;
    this.getDetail();
    this.getMyRank();
  },
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    /**
     * 获取排名列表
     */
    getDetail () {
      this.$http.get(`/api/app/checkin/rank/${this.type}/${this.id}`).then((res) => {
        this.detail.list = res.list;
      });
    },
    /**
     * 获取我的排名
     */
    getMyRank () {
      this.$http.get(`/api/app/checkin/myrank/${this.type}/${this.id}`).then((res) => {
        res.nickname = res.user.nickname;
        res.avatar = res.user.avatar;
        this.myRank = res;
        this.detail.user = res;
      });
    },
    /**
     * 切换得分与天数排名
     */
    setTYpe (index) {
      if (index == 0) {
        this.type = 'score';
      } else {
        this.type = 'days';
      }
      this.getDetail();
      this.getMyRank();
    },
    /**
     * 回到顶部
     */
    backTop () {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop () {
      const that = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.rank-page {
  min-height: 100vh;
  background: #ffffff;
  font-size: 24px;
  font-family: PingFang SC;
  /deep/ {
    .header {
      border-bottom: 1px solid #f6f6f6;
    }
    .van-tabs__wrap.van-hairline--top-bottom {
      border-bottom: 0;
    }
    .van-tabs__line {
      width: 80px !important;
    }
  }
  .detail {
    padding: 30px 30px;
  }
  .lines {
    height: 30px;
    width: 100%;
    background-color: #f6f6f6;
  }
  .record_content {
    // padding: 30px;
    font-size: 30px;
    color: #666666;
    .lines {
      height: 10px;
      background-color: #f6f6f6;
    }
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px 30px;
      span {
        display: inline-block;
        min-width: 50px;
      }
      .nickname {
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          width: 78px;
          height: 78px;
          margin: 0 30px;
          border-radius: 50%;
        }
        .name {
          width: 300px;
          word-break: break-all;
          @include lines-eps(2);
        }
      }
      i {
        font-size: 32px;
        color: #188eee;
        display: inline-block;
        width: 38px;
        height: 49px;
        vertical-align: middle;
        line-height: 49px;
        text-align: center;
      }
      .rank_icon0 {
        background-image: url("~@/assets/images/NO1.png");
        background-size: 100%;
      }
      .rank_icon1 {
        background-image: url("~@/assets/images/NO2.png");
        background-size: 100%;
      }
      .rank_icon2 {
        background-image: url("~@/assets/images/NO3.png");
        background-size: 100%;
      }
    }
    .userRank {
      padding: 0 30px;
      height: 100px;
    }
  }
  .toTop {
    width: 56px;
    height: 56px;
    position: fixed;
    right: 31px;
    bottom: 26px;
    img {
      width: 100%;
    }
  }
}
</style>
